/**************
 Header Sticky
 ***************/

// if on homepage, special header

const isIndex = document.querySelector('body').classList.contains('index');

if (isIndex) {

    const headerElement = document.querySelector('#shopify-section-theme-header');
    const announcementElement = document.querySelector('#shopify-section-theme-announcement');

    window.addEventListener('scroll', adjustHeaderCSS);

    function adjustHeaderCSS() {

        // const headerTop = headerElement.getBoundingClientRect().top;
        const announcementBottom = announcementElement.getBoundingClientRect().bottom;
        const announcementTop = announcementElement.getBoundingClientRect().top;


        if (announcementBottom <= 0) {
            headerElement.classList.add('sticky');
            headerElement.style.top = `-1px`;
            return;
        }

        if (announcementTop <= 0) {
            headerElement.classList.remove('sticky');
            headerElement.style.top = `${announcementBottom}px`;
        }
    }

    adjustHeaderCSS();
}

// wholesale login should empty cart in case of subscriptions
document.querySelector('#sliderButtonWholesale').addEventListener('click', async function (e) {
    e.preventDefault();
    // clear cart
    await fetch("/cart/clear.js");
    // reroute to login
    window.location.href = this.href;
})

/**************
 Mobile Nav
 ***************/

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector("body").classList.add("noScroll");
}

// close nav
function closeNav() {
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
    setTimeout(() => {
        document.querySelector("#slider").close();
    }, 600)
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// dialog close event
document.querySelector("#slider").addEventListener("close", () => {
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", (e) => {
        e.stopPropagation();
        closeNav();
    });
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));